import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { spacing } from 'syf-component-library/defaultTheme';
import { MessageBox } from 'syf-component-library/ui/patterns';
import { Stack } from 'syf-component-library/ui/spacing';
import { Body } from 'syf-component-library/ui/typography';
import { colors } from '../../defaultTheme';
import { FAS_EXCLAMATION_CIRCLE } from '../../const/iconProps';
import { t } from '../../strings/i18n';
const MessageBoxWrapper = styled(MessageBox) `
  border-color: ${colors.mediumWarning};
  border-width: 2px;

  div:nth-child(1) {
    width: ${spacing.large}px;
    padding-right: ${spacing.base}px;
    margin-right: 0px;
  }
  svg {
    font-size: ${spacing.large}px;
    color: ${colors.mediumWarning};
  }
`;
const DebitCardMessageBox = () => {
    return (_jsxs(MessageBoxWrapper, Object.assign({ "data-cy": "payment-method-debit-banner", icon: _jsx(FontAwesomeIcon, { icon: FAS_EXCLAMATION_CIRCLE, size: "lg" }), type: "warning" }, { children: [_jsx(Body, Object.assign({ weight: "bold" }, { children: t('addPaymentMethod.debitCardMessageBoxHeader') })), _jsx(Stack, { size: "xsmall" }), _jsx(Body, { children: t('addPaymentMethod.debitCardMessageBoxBody') })] })));
};
export default DebitCardMessageBox;
